import styled from 'styled-components';

export const StyledBestOfComponent = styled.div`
  .best-of-viewall-link {
    &::after {
      line-height: inherit;
    }
  }
`;
